import { RuleDefinition, RuleFunction } from "../type-validator";

export const custom = (...checks: RuleFunction[]): RuleDefinition => ({
  checks,
});
